/* eslint-disable react/prop-types */
import { useTable } from "react-table";
import React, { useEffect, useState } from "react";
import Card from "components/card";
import { useLocation, useNavigate } from "react-router-dom";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { IoIosSearch } from "react-icons/io";

const TableDemo = ({
  data,
  columns,
  totalCount = 1,
  title = "جدول",
  loading,
  extraComponent,
  searchExtra,
}) => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data });

  const location = useLocation();
  const navigate = useNavigate();

  // search state
  const [search, setSearch] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const searchParam = params.get("search");
    setSearch(searchParam || "");
  }, [location.search]);

  const handleSearch = (e) => {
    const params = new URLSearchParams(location.search);
    if (e.target.value === "") {
      params.delete("search");
      navigate(`${location.pathname}?${params.toString()}`);
      return;
    }
    params.set("search", e.target.value);
    navigate(`${location.pathname}?${params.toString()}`);
  };

  // Pagination state
  const [page, setPage] = useState(1);

  // Get page from URL if it exists otherwise set to 1
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pageParam = parseInt(params.get("page"), 10);
    setPage(pageParam || 1);
  }, [location.search]);

  // Handle pagination change
  const handleChangePage = (newPage) => {
    setPage(newPage);
    const params = new URLSearchParams(location.search);
    params.set("page", newPage);
    navigate(`${location.pathname}?${params.toString()}`);
  };

  // Calculate total pages
  const totalPages = Math.ceil(totalCount / 20);

  return (
    <>
      {loading ? (
        <div className="flex h-[200px] items-center justify-center rounded-xl bg-white shadow-sm dark:bg-navy-800">
          <AiOutlineLoading3Quarters className="animate-spin text-4xl text-blueSecondary dark:text-white" />
        </div>
      ) : (
        <>
          <Card extra={"w-full h-full p-4 sm:overflow-x-auto"}>
            <div className="relative flex items-center justify-between">
              <div className="text-xl font-bold text-navy-700 dark:text-white">
                {title}
              </div>
              <div className="flex items-center gap-4">
                {searchExtra && (
                  <div className="relative flex items-center gap-2 rounded-lg border border-gray-200 bg-gray-100 px-4 py-2 dark:border-navy-700 dark:bg-navy-800">
                    <input
                      className="w-full bg-gray-100 focus:outline-none dark:bg-navy-800"
                      type="search"
                      name={searchExtra}
                      id={searchExtra}
                      value={search}
                      onChange={handleSearch}
                      placeholder="ابحث..."
                    />
                    <IoIosSearch />
                  </div>
                )}
                {extraComponent && React.cloneElement(extraComponent)}
              </div>
            </div>
            <div className="mt-8 h-full overflow-x-auto">
              <table {...getTableProps()} className="w-full">
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th
                          key={column.id}
                          {...column.getHeaderProps()}
                          className="border-b border-gray-200 pb-[10px] text-start text-xs tracking-wide text-gray-600 pe-28 dark:!border-navy-700"
                        >
                          {column.render("Header")}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                {
                  // if no data

                  rows.length === 0 ? (
                    <tbody>
                      <tr>
                        <td
                          colSpan={columns.length}
                          className="py-5 text-center text-gray-400"
                        >
                          لا توجد بيانات
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <tbody {...getTableBodyProps()}>
                      {rows.map((row) => {
                        prepareRow(row);
                        return (
                          <tr {...row.getRowProps()}>
                            {row.cells.map((cell) => (
                              <td
                                key={cell.id}
                                {...cell.getCellProps()}
                                className="pt-[14px] pb-[18px] sm:text-[14px]"
                              >
                                {cell.render("Cell")}
                              </td>
                            ))}
                          </tr>
                        );
                      })}
                    </tbody>
                  )
                }
              </table>
            </div>
          </Card>

          {/* Pagination Component */}
          {totalPages > 1 && (
            <div className="mt-4 flex items-center justify-center gap-4">
              <button
                onClick={() => handleChangePage(page + 1)}
                className="flex items-center gap-2 rounded border border-blueSecondary px-4 py-2 text-blueSecondary disabled:border-0 disabled:text-gray-400"
                disabled={page === totalPages}
              >
                <FaArrowRight />
                <span>التالي</span>
              </button>
              <button
                onClick={() => handleChangePage(page - 1)}
                className="flex items-center gap-2 rounded border border-blueSecondary px-4 py-2 text-blueSecondary disabled:border-0 disabled:text-gray-400"
                disabled={page === 1}
              >
                <span>السابق</span>
                <FaArrowLeft />
              </button>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default TableDemo;
